import React, { memo } from "react";
import ImageComponent from "./ImageComponent.jsx";

const ImageWithAspectRatio = ({
  sizes,
  aspectRatio,
  height,
  src,
  alt = "Medical post media",
  onClick,
}) => {
  const sizeValue = Number(sizes || aspectRatio) || (height ? 555 / Number(height) : 1.78);

  return (
    <div
      style={{
        width: "100%",
        aspectRatio: `${sizeValue}`,
        backgroundColor: "#F8FAFC",
        position: "relative",
        overflow: "hidden",
      }}
      onClick={onClick}
    >
      <ImageComponent
        src={src}
        alt={alt}
        img_height="100%"
        img_width="100%"
        loader_height="100%"
        loader_width="100%"
        compClassName="object-cover w-100 h-100"
        onClick={onClick}
      />
    </div>
  );
};

export default memo(ImageWithAspectRatio);

